// extracted by mini-css-extract-plugin
module.exports = {"player":"Home_MobileHomepageHeroVideo_player","hidden":"Home_MobileHomepageHeroVideo_hidden"};